import { render, staticRenderFns } from "./productlist.vue?vue&type=template&id=5e6b40c6&scoped=true"
import script from "./productlist.vue?vue&type=script&lang=js"
export * from "./productlist.vue?vue&type=script&lang=js"
import style0 from "./productlist.vue?vue&type=style&index=0&id=5e6b40c6&prod&scoped=true&lang=css"
import style1 from "./productlist.vue?vue&type=style&index=1&id=5e6b40c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6b40c6",
  null
  
)

export default component.exports